import { Child } from './child';

export interface Parent<T> {
  children: T[];
}
